import React from 'react';

export const Header: React.FC = () => {
  return (
    <header className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="text-center">
          <div className="flex justify-center mb-3">
            <div className="w-12 h-12 bg-gradient-to-br from-green-600 to-blue-600 rounded-full flex items-center justify-center shadow-lg">
                <span className="text-white text-lg font-bold">RS</span>
            </div>
          </div>
          
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">
            Rathin's Portfolio
          </h1>
          
          <p className="text-base text-gray-600 mb-4 max-w-3xl mx-auto leading-relaxed">
            Passionate about building products that help people and organizations - web and mobile apps, AI, and more.
          </p>
          
          <div className="flex flex-wrap justify-center gap-3 text-sm text-gray-500">
            <div className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 bg-green-600 rounded-full"></div>
              <span>Full-Stack Developer</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 bg-blue-600 rounded-full"></div>
              <span>AI/ML Engineer</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 bg-purple-600 rounded-full"></div>
              <span>UI/UX Designer</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}; 